import React, { memo, useState } from 'react'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import Icon from '@material-ui/core/Icon'
import { injectIntl } from 'react-intl'
import { IconButton } from '@material-ui/core'
import isEmpty from 'lodash/isEmpty'
import { ReactComponent as ShowCompleted } from 'assets/img/showCompleted.svg'
import { ReactComponent as HideCompleted } from 'assets/img/hideCompleted.svg'
import messages from '../translate'

function BulkTaskHeader({
  evt_tasks,
  input_items,
  locusGroupList,
  setLocusGroupListState,
  intl: { formatMessage },
}) {
  const [search, setSearch] = useState('')
  const [showCompleted, setShowCompleted] = useState(true)
  const [hideCompletedUnits, setHideCompletedUnits] = useState([])

  const filterData = (searchValue, fullList) => {
    const filteredData = []

    locusGroupList.forEach(group => {
      let groupUnits = group.locuses

      if (!showCompleted && !fullList) {
        groupUnits = groupUnits.filter(
          ({ id }) => !hideCompletedUnits.includes(id),
        )
      }

      const filtredLocuses = groupUnits.filter(({ name }) =>
        name.includes(searchValue),
      )

      if (!isEmpty(filtredLocuses)) {
        filteredData.push({
          ...group,
          locuses: filtredLocuses,
        })
      }
    })

    setLocusGroupListState(filteredData)

    return filteredData
  }

  const filterCompletedUnits = value => {
    let hidenUnitsData = []

    if (!value) {
      const hidenDataSet = []
      const checkEvtTasks = evt_tasks && evt_tasks.length > 0
      const inputsLength = input_items.filter(
        ({ input_item_type }) => input_item_type === 'input',
      ).length

      if (checkEvtTasks) {
        evt_tasks.forEach(item => {
          if (item.evt_inputs && item.evt_inputs.length === inputsLength) {
            hidenDataSet.push(item.locus)
          }
        })
      }

      setHideCompletedUnits(hidenDataSet)

      const filteredData = filterData(search)

      filteredData.forEach(group => {
        let groupUnits = group.locuses

        groupUnits = groupUnits.filter(({ id }) => !hidenDataSet.includes(id))

        if (!isEmpty(groupUnits)) {
          hidenUnitsData.push({
            ...group,
            locuses: groupUnits,
          })
        }
      })
    } else {
      hidenUnitsData = filterData(search, 'fullList')
    }

    setLocusGroupListState(hidenUnitsData)
  }

  const handleValueChange = ({ target: { value } }) => {
    setSearch(value)
    filterData(value)
  }

  const handleFilterChange = value => () => {
    setShowCompleted(value)
    filterCompletedUnits(value)
  }

  return (
    <div className="bulk-task-header">
      {showCompleted ? (
        <IconButton
          className="bulk-filter"
          onClick={handleFilterChange(!showCompleted)}>
          <ShowCompleted />
        </IconButton>
      ) : (
        <IconButton
          className="bulk-filter"
          onClick={handleFilterChange(!showCompleted)}>
          <HideCompleted />
        </IconButton>
      )}
      <Input
        className="bulk-search"
        placeholder={formatMessage(messages.search)}
        onChange={handleValueChange}
        startAdornment={
          <InputAdornment position="start">
            <Icon fontSize="small">search</Icon>
          </InputAdornment>
        }
        value={search}
        disableUnderline
      />
    </div>
  )
}

export default memo(injectIntl(BulkTaskHeader))
